/* eslint-disable no-param-reassign */
// this is what @reduxjs/toolkit expects
import { createAction, createAsyncThunk, createReducer } from '@reduxjs/toolkit'
import { redFunnelAPI } from 'api/api'
import getErrorMessage from 'utilities/getErrorMessage'

const initialState = {
  isLoading: false,
  isError: null,
  data: null,
  feed: [],
}

export const fetchMyRewards = createAsyncThunk('myRewards/fetch', id =>
  redFunnelAPI
    .getLoyaltyPoints(id)
    .then(({ data }) => {
      const loyaltyPoints = data?.loyaltyAccount || null
      return loyaltyPoints
    })
    .catch(err => {
      const message = getErrorMessage(err, 'Unauthorized myRewards')
      throw new Error(message)
    }),
)

export const setRewardsFeed = createAction('myRewards/feed')

export const myRewardsReducer = createReducer(initialState, builder => {
  builder
    .addCase(fetchMyRewards.pending, state => {
      state.isLoading = true
    })
    .addCase(fetchMyRewards.fulfilled, (state, action) => {
      state.isLoading = false
      state.data = action.payload
      state.isError = null
    })
    .addCase(fetchMyRewards.rejected, (state, action) => {
      state.isLoading = false
      state.data = null
      state.isError = action.payload
    })
    .addCase(setRewardsFeed, (state, action) => {
      state.feed = action.payload
    })
})

export const selectMyRewardsState = state => state.myRewards
